import("./flying-focus/FlyingFocus.js");

if (process.env.NODE_ENV === "development") {
    const tailwindCdnTag = document.createElement("script");
    tailwindCdnTag.src = "https://cdn.tailwindcss.com/3.2.4";
    const config = require("../../../../../theme");
    tailwindCdnTag.onload = () => {
        const tailwindConfigTag = document.createElement("script");
        tailwindConfigTag.innerHTML = "tailwind.config = " + JSON.stringify(config);
        document.head.appendChild(tailwindConfigTag);
    };
    document.head.prepend(tailwindCdnTag);
}
